import script from "./CreateNewAppDialog.vue?vue&type=script&setup=true&lang=tsx"
export * from "./CreateNewAppDialog.vue?vue&type=script&setup=true&lang=tsx"

import "./CreateNewAppDialog.vue?vue&type=style&index=0&id=d75c4780&lang=less&scoped=true"
import "./CreateNewAppDialog.vue?vue&type=style&index=1&id=d75c4780&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d75c4780"]])

export default __exports__